<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ $t('Turnover-Analysis-Report') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>


            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

                    <v-layout row wrap>
                      <v-flex sm2 md2 pl-1 pt-2>
                        <v-autocomplete clearable="" v-model="Rapor.Yil" :label="$t('YEAR')" :items="tarihitems"
                          :rules="[v => !!v || 'Lütfen yıl seçiniz']" cache-items=""> </v-autocomplete>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>

                </v-card>
              </v-flex>

              <v-flex xs12 v-if="itemssatis.length>0" sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 pa-1 sm12 md12>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title> <span class="subheading grey--text">
                          <v-icon color="grey">view_list</v-icon> {{ $t('List-Turnover-Current-Account') }}
                        </span> </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-flex>
                  <v-flex xs12 sm12 md6 pa-1 v-for="item in itemssatis" :key="item.id ">
                    <v-card flat>
                      <v-layout row wrap class="pa-3 project overdue">
                        <v-flex pt-1 pb-1 sm112 xs12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm10 xs12 md9>
                              <div class="subtitle-2 font-weight-	  grey--text">
                                <v-icon color="grey">account_box </v-icon> &nbsp; {{item.Cari.Kod}}-{{item.Cari.Unvan}}
                              </div>
                            </v-flex>

                            <v-flex xs12 sm2 md3>
                              <v-layout wrap align-center fill-height justify-center="">
                                <v-flex xs12 sm12 md12>
                                  <v-layout justify-center="">
                                    <span class="body-1 red--text font-weight-">
                                      {{item.ToplamTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                  <v-divider></v-divider>
                                  <v-layout justify-center="">
                                    <span class="caption grey--text ">
                                      {{ $t('Total-Revenue') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 md12>
                          <v-layout row wrap>

                            <v-flex xs12 md6>
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md6>
                                  <v-layout row wrap>
                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="caption	 justify-center   grey--text">{{ $t('January') }} :</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-end align-center fill-height caption ">
                                          {{item.OcakTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="caption	 justify-center   grey--text">{{ $t('February') }} :</div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-end caption ">{{item.SubatTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="caption	 justify-center   grey--text">{{ $t('March') }} :</div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-end caption ">{{item.MartTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md6>
                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="justify-center caption grey--text"> {{ $t('April') }} :</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-center caption ">{{item.NisanTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>




                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="justify-center caption grey--text">{{ $t('May') }} :</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-center caption ">{{item.MayisTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="justify-center caption grey--text">{{ $t('June') }}:</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-center caption ">{{item.HaziranTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                            <v-flex xs12 md6>
                              <v-layout row wrap>


                                <v-flex xs12 sm12 md6>
                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="caption	 justify-center   grey--text">{{ $t('July') }} :</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-end caption">{{item.TemmuzTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="caption	 justify-center   grey--text">{{ $t('August') }}  :</div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-end caption ">{{item.AgustosTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="caption	 justify-center   grey--text">{{ $t('September') }}:</div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-end caption ">{{item.EylulTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>



                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md6>
                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="justify-center caption grey--text">{{ $t('October') }}:</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-center caption ">{{item.EkimTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>




                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="justify-center caption grey--text">{{ $t('November') }}:</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-center caption ">{{item.KasimTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-left>
                                        <div class="justify-center caption grey--text"> {{ $t('December') }}:</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>
                                      <v-layout justify-end>
                                        <div class="justify-center caption ">{{item.AralikTutar | moneyformat }}{{getparabirimi()}}</div>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                      </v-layout>
                      <v-divider></v-divider>
                    </v-card>


                  </v-flex>
                </v-layout>

              </v-flex>


              <br />


              <v-flex xs12 v-if="itemssatis.length>0" sm12 md12 pa-1>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-toolbar flat="" size="120px" dark color="white">
                            <v-toolbar-title> <span class="subheading grey--text">
                                <v-icon color="grey">show_chart</v-icon> {{ $t('Grand-Total') }} :
                                {{genelToplamCiro | moneyformat }}{{getparabirimi()}}
                              </span> </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-flex>

                        <v-flex xs12 md12>
                          <ve-histogram :data="chartData" :judge-width="true" :settings="chartSettings"></ve-histogram>
                        </v-flex>



                      </v-layout>

                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
     

                            <cariaracomp v-bind:etiket="$t('Main-Account')" v-bind:value="Rapor.AnaHesap" :loading="loadingana" v-model="Rapor.AnaHesap"></cariaracomp>

                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-select :items="hesapgrubu" hide-details="" v-model="Rapor.HesapGrubu"
                                :label="$t('Account-Group-Requested')" multiple item-text="Adi" item-value="Kod"
                                max-height="400"></v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-select :items="nohesapgrubu" hide-details="" v-model="Rapor.NoHesapGrubu"
                                :label="$t('Account-Group-Not-Requested')" multiple item-text="Adi" item-value="Kod"
                                max-height="400"></v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                
                            <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.Cari.Kod" :loading="loading" v-model="Rapor.Cari.Kod"></cariaracomp>

                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <!-- <v-select :items="referansitems" hide-details v-model="Rapor.Referanslar"
                                :label="$t('Reference')" multiple item-text="Title" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                  Rapor.Referanslar - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select> -->
                              <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="ReferansPrm.Kod" >
                              </referansmerkezicomp>
                            </v-flex>



                            <v-flex xs12 sm12 md12>
                              <v-checkbox :label="$t('Deduct-Current-VAT-Amount')" v-model="Rapor.CariKdvTutar" hide-details="">
                              </v-checkbox>
                              <v-checkbox :label="$t('Account-Name')" v-model="Rapor.HesapAdi" hide-details=""></v-checkbox>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>
                            
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import VeBar from 'v-charts/lib/bar.common'
  import VeHistogram from 'v-charts/lib/histogram.common'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'



  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        ReferansPrm: {
                Kod: null},
        genelToplamCiro: 0,
        chartData: {
          columns: ['ay', 'ciro'],
          rows: [{
              'ciro': 10,
              'ay': 'Ocak'
            },
            {
              'ciro': 20,
              'ay': 'Şubat'
            },
            {
              'ciro': 5,
              'ay': 'Mart'
            },
            {
              'ciro': 1,
              'ay': 'Nisan'
            },
            {
              'ciro': 26,
              'ay': 'Mayıs'
            },
            {
              'ciro': 10,
              'ay': 'Haziran'
            },
            {
              'ciro': 20,
              'ay': 'Temmuz'
            },
            {
              'ciro': 5,
              'ay': 'Ağustos'
            },
            {
              'ciro': 1,
              'ay': 'Eylül'
            },
            {
              'ciro': 26,
              'ay': 'Ekim'
            },
            {
              'ciro': 10,
              'ay': 'Kasım'
            },
            {
              'ciro': 20,
              'ay': 'Aralık'
            }
          ]
        },
        chartSettings: {
          colors: ['#F44336'],

          label: {
            normal: {
              show: true,
              position: "top"
            }
          },

          yAxisName: ['Top. Ciro'],
          yAxisType: ['0']
        },




        filtrevarmi: false,
        referansitems: [],
        search: '',
        searchsatilanbilet: null,
        tarihitems: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010,
          2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028,
          2029, 2030
        ],


        headers: [{
            text: 'Cari',
            value: 'Cari.Kod'
          },
          {
            text: 'Ocak',
            value: 'OcakTutar',
          },
          {
            text: 'Şubat',
            value: 'SubatTutar',
          },
          {
            text: 'Mart',
            value: 'MartTutar',
          },
          {
            text: 'Nisan',
            value: 'NisanTutar',
          },
          {
            text: 'Mayis',
            value: 'MayisTutar',
          },
          {
            text: 'Haziran',
            value: 'HaziranTutar',
          },
          {
            text: 'Temmuz',
            value: 'TemmuzTutar',
          },
          {
            text: 'Ağustos',
            value: 'AgustosTutar',
          },
          {
            text: 'Eylül',
            value: 'EylulTutar',
          },
          {
            text: 'Ekim',
            value: 'EkimTutar',
          },
          {
            text: 'Kasım',
            value: 'KasimTutar',
          },
          {
            text: 'Aralik',
            value: 'AralikTutar',
          }
        ],
        headers2: [{
            text: 'Ocak',
            value: 'GenelOcakTutar',
          },
          {
            text: 'Şubat',
            value: 'GenelSubatTutar',
          },
          {
            text: 'Mart',
            value: 'GenelMartTutar',
          },
          {
            text: 'Nisan',
            value: 'GenelNisanTutar',
          },
          {
            text: 'Mayis',
            value: 'GenelMayisTutar',
          },
          {
            text: 'Haziran',
            value: 'GenelHaziranTutar',
          },
          {
            text: 'Temmuz',
            value: 'GenelTemmuzTutar',
          },
          {
            text: 'Ağustos',
            value: 'GenelAgustosTutar',
          },
          {
            text: 'Eylül',
            value: 'GenelEylulTutar',
          },
          {
            text: 'Ekim',
            value: 'GenelEkimTutar',
          },
          {
            text: 'Kasım',
            value: 'GenelKasimTutar',
          },
          {
            text: 'Aralik',
            value: 'GenelAralikTutar',
          },
          {
            text: this.$t('Grand-Total'),
            value: 'GenelToplamTutar',
          }
        ],

        GenelToplamlar: [],


        hesapgrubu: [],
        nohesapgrubu: [],

        Rapor: {
          AnaHesap: null,
          HesapGrubu: [],
          NoHesapGrubu: [],
          Yil: null,
          CariKdvTutar: false,
          HesapAdi: false,
          Cari: {
            Kod: null,
          },
          SirketKodu: null,
          Referanslar: [],
        },



        valid: true,
        tumsirketler: '',
        loadingana: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',
        statecariana: [],
        searchcariana: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],

        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {


        this.Rapor.Yil = helpers.getYear();

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }


        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapgurubu = response.body
          this.nohesapgrubu = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })


        // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   this.referansitems = response.body
        // }, (response) => {
        //   if (response.status === 0) {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   } else {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   }
        // })




        this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.evraktipi = response.body

        }, (response) => {
          if (response.status === 0) {

          } else {

          }
        })



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      VeBar,
      VeHistogram,
      yetkidialog,
      cariaracomp
    },
    watch: {

    },
    methods: {
          getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }

  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgrubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {

      } else {

      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {

    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.Cari.Kod = null
    this.Rapor.Evraklar = []
    this.Rapor.Referanslar = []
    this.Rapor.Tip = '0'

  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      this.progress = true
      this.chartData.rows = []
      this.load1 = false

      var listreferans = [];

      this.Rapor.Referanslar=[];
      if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
      {
        this.Rapor.Referanslar.push(this.ReferansPrm.Kod);
      }
      this.Rapor.Referanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        listreferans.push(kayit)
      });

      this.Rapor.Referanslar = listreferans



      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http.post(auth.API_URL + 'api/Report/EndorsementAnalyseReport', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.GenelToplamlar = []


        this.genelToplamCiro = response.body.GenelToplamTutar
        this.GenelToplamlar.push(response.body)

        this.itemssatis = response.body.CiroAnalizDetay

        var toplamkayit = []

        var kayit = {
          ciro: response.body.GenelOcakTutar,
          ay: 'Ocak'
        }
        this.chartData.rows.push(kayit)
        kayit = {
          ciro: response.body.GenelSubatTutar,
          ay: 'Şubat'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelMartTutar,
          ay: 'Mart'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelNisanTutar,
          ay: 'Nisan'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelMayisTutar,
          ay: 'Mayıs'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelHaziranTutar,
          ay: 'Haziran'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelTemmuzTutar,
          ay: 'Temmuz'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelAgustosTutar,
          ay: 'Ağustos'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelEylulTutar,
          ay: 'Eylül'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelEkimTutar,
          ay: 'Ekim'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelKasimTutar,
          ay: 'Kasım'
        }
        this.chartData.rows.push(kayit)

        kayit = {
          ciro: response.body.GenelAralikTutar,
          ay: 'Aralık'
        }
        this.chartData.rows.push(kayit)






        this.progress = false
        this.load1 = true

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })

    }
  }



  function getListHtml() {


    if (this.$refs.formgunluksatis.validate()) {


      this.progress = true
      this.load1 = false

      var listreferans = [];
      this.Rapor.Referanslar=[];
      if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
      {
        this.Rapor.Referanslar.push(this.ReferansPrm.Kod);
      }
      this.Rapor.Referanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        listreferans.push(kayit)
      });

      this.Rapor.Referanslar = listreferans


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      var params = this.Rapor
      this.$http
        .post(auth.API_URL + "api/Report/EndorsementAnalyseReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.GenelToplamlar = []

          this.GenelToplamlar.push(response.body)

          this.itemssatis = response.body.CiroAnalizDetay
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "CiroAnalizRaporu.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }


  function getListExcel() {


    if (this.$refs.formgunluksatis.validate()) {


      this.progress = true
      this.load1 = false

      var listreferans = [];
      this.Rapor.Referanslar=[];
      if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
      {
        this.Rapor.Referanslar.push(this.ReferansPrm.Kod);
      }
      this.Rapor.Referanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        listreferans.push(kayit)
      });

      this.Rapor.Referanslar = listreferans


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      var params = this.Rapor
      this.$http
        .post(auth.API_URL + "api/Report/EndorsementAnalyseReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.GenelToplamlar = []

          this.GenelToplamlar.push(response.body)

          this.itemssatis = response.body.CiroAnalizDetay
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "CiroAnalizRaporu.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }


  function beforeMount() {

  }
</script>
<style>
  .project.complete {
    border-left: 4px solid #039BE5;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid tomato;
  }
</style>